export default __webpack_public_path__ + "static/logo_prestashop-616c04d0a0024eb94d7a9d535b13ea24.jpg";